import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "select", "participantActions", "participantRow", "participantName", "vote", "voteSummary", "current", "picker" ]
  static values = { storageKey: String, alwaysShowSelect: Boolean }

  connect() {
    const participantId = window.localStorage.getItem(this.storageKeyValue)
    if (participantId && this.hasSelectTarget) this.selectTarget.value = participantId
    this.updateForms()
  }

  select() {
    window.localStorage.setItem(this.storageKeyValue, this.selectTarget.value)
    this.updateForms()
  }

  updateForms() {
    if (this.hasSelectTarget) {
      const selectedParticipantId = this.selectTarget.value

      this.participantActionsTargets.forEach((container) => {
        const participantId = container.dataset.participantPickerParticipantId
        container.hidden = !selectedParticipantId || participantId !== selectedParticipantId
      })
      this.participantRowTargets.forEach((row) => {
        const participantId = row.dataset.participantPickerParticipantId
        const listing = row.closest("article")
        const selectedActions = listing?.querySelector(
          `[data-participant-picker-target="participantActions"][data-participant-picker-participant-id="${selectedParticipantId}"]`
        )
        const selectedParticipantVoted = selectedActions?.dataset.hasOpinion === "true"
        const isSelectedParticipant = participantId === selectedParticipantId
        row.hidden = Boolean(selectedParticipantId) && !selectedParticipantVoted && !isSelectedParticipant
        const name = row.querySelector("[data-participant-picker-target=\"participantName\"]")
        if (name) name.hidden = isSelectedParticipant && !selectedParticipantVoted
      })
      this.voteTargets.forEach((vote) => {
        const participantId = vote.dataset.participantPickerParticipantId
        const listing = vote.closest("article")
        const selectedActions = listing?.querySelector(
          `[data-participant-picker-target="participantActions"][data-participant-picker-participant-id="${selectedParticipantId}"]`
        )
        const selectedParticipantVoted = selectedActions?.dataset.hasOpinion === "true"
        const isSelectedParticipant = participantId === selectedParticipantId
        vote.hidden = !selectedParticipantVoted
        const summary = this.voteSummaryTargets.find((item) => item.dataset.participantPickerParticipantId === participantId && item.closest("article") === listing)
        if (summary) {
          summary.hidden = selectedParticipantVoted || isSelectedParticipant
          summary.textContent = isSelectedParticipant && !selectedParticipantVoted ? "À vous de voter" : summary.dataset.defaultLabel
        }
      })
      if (this.hasCurrentTarget) {
        const label = this.selectTarget.selectedOptions[0]?.textContent
        this.currentTarget.textContent = label ? "Participant actif : " + label : ""
        this.currentTarget.hidden = this.alwaysShowSelectValue || !this.selectTarget.value
      }
      if (this.hasPickerTarget) this.pickerTarget.hidden = this.alwaysShowSelectValue || Boolean(this.selectTarget.value)
    }
  }
}
